// #region Imports
import { AppBar, Toolbar, Typography, Box } from "@mui/material";
import { Link } from "@tanstack/react-router";
import ThemeToggleMolecule from "../../molecules/ThemeToggle/theme-toggle.molecule";
import LanguageSelector from "../../atoms/LanguageSelector/language-selector.atom";
// #endregion

// #region Component
/**
 * Navbar organism component that provides the main navigation bar for the application
 * Uses MUI AppBar and Toolbar components for consistent Material Design styling
 * Positioned at the top of the application layout
 */
function Navbar() {
    return (
        <AppBar
            position="sticky"
            sx={{
                top: 0,
                zIndex: theme => theme.zIndex.appBar,
            }}
        >
            <Toolbar>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    <Link
                        id="navbar-home-link"
                        to="/"
                        style={{
                            textDecoration: "none",
                            color: "inherit",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: 12,
                        }}
                    >
                        <img src="/images/logo.svg" alt="logo" role="presentation" style={{ height: 40 }} />
                        <Typography variant="h6" component="span">
                            Furniturr
                        </Typography>
                    </Link>
                </Typography>
                <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                    <LanguageSelector showLabel={false} size="small" colorMode="navbar" />
                    <ThemeToggleMolecule />
                </Box>
            </Toolbar>
        </AppBar>
    );
}
// #endregion

// #region Exports
export default Navbar;
// #endregion
